import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { useProfileSettings } from './useProfileStores';
import { appConfig, isCompanyTypeIdMNOHost } from '../../settings';
import { ICatalogsUnitItem, ISelect, ISelectList } from '../../interfaces';
import { UnitTypeValues, getVisibleUnitTypeValues } from '../../middleware';

export const useRateUnitTypeSelect = (): ICatalogsUnitItem[] => {
    return useContext(MobXProviderContext).RootStore.catalogsStore.rateUnitTypeSelect;
};

export function useOriginalUnitTypeSelect(): ISelectList {
    return useContext(MobXProviderContext).RootStore.catalogsStore.originalUnitTypeSelect;
}

/** Unit types the tenant may see, per its tenant config. Data, SMS, Voice order. */
export function useVisibleUnitTypes(): UnitTypeValues[] {
    return getVisibleUnitTypeValues(useProfileSettings());
}
export function useVisibleOriginalUnitTypeSelect(): ISelectList {
    const visibleUnitTypes = useVisibleUnitTypes();
    return useOriginalUnitTypeSelect().filter((i: ISelect) => visibleUnitTypes.includes(`${i.id}` as UnitTypeValues));
}
export function useDataUnitTypeSelect(): ISelectList {
    return useContext(MobXProviderContext).RootStore.catalogsStore.dataUnitTypeSelect;
}
export function useRatesImportTypes(): ISelectList {
    return useContext(MobXProviderContext).RootStore.catalogsStore.importTypeSelect;
}

export function useCatalogCompanyTypeSelect(): ISelectList {
    return useContext(MobXProviderContext).RootStore.catalogsStore.companyTypes;
}
export function useCatalogCompanyTypeFilterNotMNOSelect(): ISelectList {
    return useContext(MobXProviderContext).RootStore.catalogsStore.companyTypes.filter(
        (i: ISelect) => !isCompanyTypeIdMNOHost(i.id),
    );
}

export function useCatalogPaymentTypesSelect(): ISelectList {
    return useContext(MobXProviderContext).RootStore.catalogsStore.paymentTypes;
}
export function useCatalogOredablesSelect(): ISelectList {
    return useContext(MobXProviderContext).RootStore.catalogsStore.productTypes;
}

export function useCatalogSessionGrantedTypesSelect(currency = 'currency'): ISelectList {
    return appConfig.sessionGrantedTypes.map((i: ISelect) => {
        if (i.name === 'currency') {
            return { ...i, name: currency };
        } else {
            return i;
        }
    });
}
